import { FC } from 'react';
import { BvIcon } from 'bevi-icon';
import FormatMoney from '../../../../../utils/FormatMoney';
import { UltimaSimulacao } from '../../../../../models/SimulationBank/SimulationBankModels';

// SB-1953 — histórico de referência da última simulação do cliente, exibido acima dos
// campos da nova. Só aparece quando o /consult devolve ULTIMA_SIMULACAO (ver
// handleTriagem): cliente sem histórico não traz a chave, e aí não há card.

const MODO_LABELS: Record<string, string> = {
    VALOR_PARCELA: 'Valor Parcela',
    VALOR_DESEJADO: 'Valor Desejado',
    VALOR_TOTAL: 'Valor Total',
};

// Só o eixo efetivamente simulado é devolvido — o outro vem omitido. Ausência é "não se
// aplica", nunca zero, então nada pode cair num FormatMoney(undefined), que renderizaria
// R$ 0,00 e faria a tela afirmar um valor que a simulação nunca teve.
const EMPTY = '-';

const formatModo = (modo?: string): string => {
    if (!modo) return EMPTY;
    return MODO_LABELS[modo]
        ?? modo.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
};

const formatDataSimulacao = (iso?: string): string => {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    const data = d.toLocaleDateString('pt-BR');
    const hora = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    return `${data} às ${hora}`;
};

interface UltimaSimulacaoCardProps {
    ultimaSimulacao: UltimaSimulacao;
}

const UltimaSimulacaoCard: FC<UltimaSimulacaoCardProps> = ({ ultimaSimulacao }) => {
    const { MODO, QTDE_PARCELAS, VALOR_SOLICITADO, VALOR_PARCELA, DATA_SIMULACAO } = ultimaSimulacao;
    const dataSimulacao = formatDataSimulacao(DATA_SIMULACAO);

    const itens = [
        { label: 'Modo', value: formatModo(MODO) },
        { label: 'Parcelas', value: QTDE_PARCELAS != null ? `${QTDE_PARCELAS}x` : EMPTY },
        { label: 'Valor Solicitado', value: VALOR_SOLICITADO != null ? FormatMoney(VALOR_SOLICITADO) : EMPTY },
        { label: 'Valor Parcela', value: VALOR_PARCELA != null ? FormatMoney(VALOR_PARCELA) : EMPTY },
    ];

    return (
        <div className="ultima-simulacao">
            <div className="ultima-simulacao__header">
                <span className="ultima-simulacao__badge">
                    <BvIcon name="assignment" variant="dark" width={14} height={14} />
                    Última simulação realizada
                </span>
                {dataSimulacao && <span className="ultima-simulacao__date">{dataSimulacao}</span>}
            </div>

            <div className="ultima-simulacao__grid">
                {itens.map((item) => (
                    <div className="ultima-simulacao__item" key={item.label}>
                        <span className="ultima-simulacao__label">{item.label}</span>
                        <span className="ultima-simulacao__value">{item.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UltimaSimulacaoCard;
